<ng-container *ngIf="kfi.isPurchase">
  <boi-form-numeric-input
    [isFieldDisabled]="isReadOnly"
    [labelName]="referenceDataLabels.WhatIsTheorPriceOfTheProId"
    [isCurrency]="true"
    [(value)]="kfi.PurchasePropertyPrice"
    (valueChange)="isFeeUpToDateChange.emit(false)"
    [propertyNames]="['PurchasePropertyPrice']"
    [fieldMaxLength]="7"
  ></boi-form-numeric-input>

  <boi-form-radio-button
    [optionList]="referenceDataOptionLists.AnswerType"
    [labelName]="referenceDataLabels.AreYouPurchasingAtAConcessionaId"
    [(value)]="kfi.PurchasingAtConcessionaryPriceCode"
    [isFieldDisabled]="isReadOnly"
    [propertyNames]="['PurchasingAtConcessionaryPriceCode']"
    [contextualHelpName]="ReferenceDataContextualHelps.KfiPurchaseConcessionary"
  >
  </boi-form-radio-button>

  <ng-container *ngIf="kfi.PurchasingAtConcessionaryPriceCode === referenceDataOptionLists.AnswerTypeYes">
    <boi-form-numeric-input
      [labelName]="referenceDataLabels.WhatIsTheTrueMarketValueOfThePId"
      [isCurrency]="true"
      [fieldMaxLength]="7"
      [(value)]="kfi.TrueMarketPrice"
      (valueChange)="isFeeUpToDateChange.emit(false)"
      [isFieldDisabled]="isReadOnly"
      [propertyNames]="['TrueMarketPrice']"
    >
    </boi-form-numeric-input>
  </ng-container>
</ng-container>

<ng-container *ngIf="kfi.isRemortgage">
  <boi-form-numeric-input
    [labelName]="referenceDataLabels.WhatIsTheEstimatedValueOfProp"
    [isCurrency]="true"
    [isFieldDisabled]="isReadOnly"
    [(value)]="kfi.RemortgageEstimatedPropertyValue"
    (valueChange)="isFeeUpToDateChange.emit(false)"
    [fieldMaxLength]="7"
    [propertyNames]="['RemortgageEstimatedPropertyValue']"
    [contextualHelpName]="
      kfi.isBuyToLet
        ? ReferenceDataContextualHelps.AppPropertyEstimatedValueBtl
        : ReferenceDataContextualHelps.AppPropertyEstimatedValueResidential
    "
  >
  </boi-form-numeric-input>
</ng-container>

<div class="dots-separator"></div>

<boi-form-kfi-product-selection
  [kfi]="kfi"
  [allowsExpiredProduct]="kfi.AllowsExpiredProduct"
  (productChange)="isFeeUpToDateChange.emit(false)"
>
</boi-form-kfi-product-selection>

<div class="dots-separator"></div>

<!--8 & 8.6-->
<boi-form-numeric-input
  [labelName]="referenceDataLabels.AmountToBorrowId"
  [isCurrency]="true"
  [value]="kfi?.LoanAmountCache"
  (valueChange)="setLoanAmount($event)"
  [propertyNames]="['LoanAmount']"
  [isFieldDisabled]="kfi?.IsApplicationReadOnly"
  [fieldMaxLength]="8"
  [contextualHelpName]="
    kfi.isBuyToLet
      ? ReferenceDataContextualHelps.AppLoanAmmountBtl
      : kfi.isAdvisedCase
      ? ReferenceDataContextualHelps.AdvisedAppLoanAmmountResidential
      : ReferenceDataContextualHelps.AppLoanAmmountResidential
  "
>
</boi-form-numeric-input>

<!--9 & 10-->
<boi-form-term-input
  [labelName]="referenceDataLabels.BorrowingTermId"
  [contextualHelpName]="
    kfi.isBuyToLet
      ? 'KfiBorrowingTermBtl'
      : kfi.isAdvisedCase
      ? 'AdvisedKfiBorrowingTermResidential'
      : 'KfiBorrowingTermResidential'
  "
  [(years)]="kfi.CaseProducts[0].LoanTermYears"
  (yearsChange)="
    partAndPartProductService.isProductPartRepaymentPartInterest && (kfi.CaseProducts[1].LoanTermYears = $event)
  "
  [(months)]="kfi.CaseProducts[0].LoanTermMonths"
  (monthsChange)="
    partAndPartProductService.isProductPartRepaymentPartInterest && (kfi.CaseProducts[1].LoanTermMonths = $event)
  "
  [isFieldDisabled]="kfi?.IsApplicationReadOnly"
  [propertyNames]="[
    'LoanTerm',
    'LoanTermYears',
    'CaseProduct_0.LoanTerm',
    'CaseProduct_0.LoanTermYears',
    'CaseProduct_0.LoanTermMonths'
  ]"
>
</boi-form-term-input>

<!--11-->
<boi-form-option-list
  [optionList]="referenceDataOptionLists.RepaymentType"
  [labelName]="referenceDataLabels.RepaymentTypeId"
  [propertyNames]="['CaseProduct_0.RepaymentTypeCode']"
  [isFieldDisabled]="kfi?.IsApplicationReadOnly"
  [value]="kfi.RepaymentTypeCodeCache"
  (valueChange)="setRepaymentType($event)"
  [contextualHelpName]="'KfiRepaymentType'"
></boi-form-option-list>

<ng-container *ngIf="partAndPartProductService.isProductPartRepaymentPartInterest">
  <boi-part-and-part-control
    [interestOnlyPart]="kfi.CaseProducts[0]?.LoanAmount"
    (interestOnlyPartChange)="setInterestOnlyPart($event)"
    [repaymentPart]="kfi.CaseProducts[1]?.LoanAmount"
    [totalLoan]="kfi.LoanAmountCache"
    [isReadOnly]="kfi.IsApplicationReadOnly"
    [isKfi]="true"
  ></boi-part-and-part-control>
</ng-container>

<div class="dots-separator"></div>
